 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A1_COVER from '@/components/01_cover'
 import LOVE_1 from '@/components/love_1'
 import A2_BOOKHALFTITLE from '@/components/02_bookhalftitle'
 import A3_COPYRIGHTTITLE from '@/components/03_copyrighttitle'
 import A4_BOOKTITLE from '@/components/04_booktitle'
 import A5_PREFACETITLE from '@/components/05_prefacetitle'
 import A6_CHAPTERTITLE1 from '@/components/06_chaptertitle1'
 import LOVE_2 from '@/components/love_2'
 import A7_INDEXTITLE from '@/components/07_indextitle'
 import A8_ACKTITLE from '@/components/08_acktitle'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/01_cover",
 			"name" : "01_cover",
 			"component" : A1_COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/02_bookhalftitle",
 			"name" : "02_bookhalftitle",
 			"component" : A2_BOOKHALFTITLE
 		},
 		{
 			"path" : "/03_copyrighttitle",
 			"name" : "03_copyrighttitle",
 			"component" : A3_COPYRIGHTTITLE
 		},
 		{
 			"path" : "/04_booktitle",
 			"name" : "04_booktitle",
 			"component" : A4_BOOKTITLE
 		},
 		{
 			"path" : "/05_prefacetitle",
 			"name" : "05_prefacetitle",
 			"component" : A5_PREFACETITLE
 		},
 		{
 			"path" : "/06_chaptertitle1",
 			"name" : "06_chaptertitle1",
 			"component" : A6_CHAPTERTITLE1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js